import { redraw, screen_to_image, image_to_screen } from "./viewer";

let MeasuringToolColorMap = [
  "#E57373",
  "#F06292",
  "#BA68C8",
  "#9575CD",
  "#7986CB",
  "#64B5F6",
  "#4FC3F7",
  "#4DD0E1",
  "#4DB6AC",
  "#81C784",
  "#AED581",
  "#DCE775",
  "#FFF176",
  "#FFD54F",
  "#FFB74D",
  "#FF8A65",
  "#A1887F",
  "#9E9E9E",
];

class measuringToolColors {
  constructor() {
    this.colors = [...MeasuringToolColorMap];
  }
}

export class MeasuringTool {
  sections = [];
  totalLength = null;
  isSectionOpen = false;
  isEditing = false;
  isOpen = false;
  viewerRef = null;
  MeasuringToolColorMap = new measuringToolColors();
  $toggler;
  $context;

  constructor(Viewer) {
    $(`<div id="measuring_tool">
            <div id="measuring_tool_toggle_feature">
            <i class="icon"></i>
            </div>
            <div class="wrapper">
                <ul>
                </ul>
                <div id="measuring_tool_total_length">
                    <span class="sum_label">${window.app.t("measuring_tool.total")}</span>
                    <span class="value"></span>
                </div>
                <div class="actions">
                <div id="measuring_tool_add_section" title="${window.app.t("measuring_tool.add")}">
                    <i class="icon"></i>
                </div>
                <div id="measuring_tool_reset" title="${window.app.t("measuring_tool.clear")}">
                    <i class="icon"></i>
                </div>
                <div id="measuring_tool_save_to_context">${window.app.t(
                  "measuring_tool.replace"
                )}</div>
                </div>
            </div>
        </div>`).appendTo($("#measuring-tool-insert"));

    this.viewerRef = Viewer;
    this.$root = $("#measuring_tool");
    this.$total = $("#measuring_tool_total_length");
    this.$featureToggler = $("#measuring_tool_toggle_feature");
    this.$addSection = $("#measuring_tool_add_section");
    this.$reset = $("#measuring_tool_reset");
    this.$wrapper = this.$root.find(".wrapper");
    this.$saveToContextButton = this.$root.find("#measuring_tool_save_to_context");
    this.$featureToggler.on("click", this.toggleEditable.bind(this));
    this.$addSection.on("click", this.addSection.bind(this));
    this.$reset.on("click", this.reset.bind(this));
    this.$saveToContextButton.on("click", this.saveToContext.bind(this));
    $(this.viewerRef.canvas_2d).bind("contextmenu", this.handleCanvasInteraction.bind(this));

    // YUCK!
    $("body").bind("ibex:slide-selected", this.resetAndHide.bind(this));
    $(document).on("set-measuring-context", (event, data) => {
      this.setContext(data.key);
      if (!data.key) {
        this.toggleEditable();
      }
    });
    this.$featureToggler.show();
  }

  get value() {
    return this.totalLength;
  }

  calculateTotalLength() {
    let sumLength = 0;
    this.sections.map(function (section) {
      sumLength += section.length;
    });
    this.totalLength = sumLength;
  }

  addSection() {
    this.sections.push(
      new MeasuringToolSection(this.viewerRef, this.MeasuringToolColorMap.colors.splice(0, 1))
    );
    this.isSectionOpen = true;
    this.render();
  }

  removeSection(e) {
    let index = $(e.target.parentNode).index();
    this.MeasuringToolColorMap.colors.push(this.sections[index].color);
    this.sections.splice(index, 1);
    $(e.target.parentNode).remove();
    if (this.sections.length === 0) {
      this.init();
    } else {
      redraw();
    }
  }

  addCoordinatesToSection(image_position) {
    this.sections[this.sections.length - 1].addCoords(image_position);
    this.render();
  }

  toggleEditable() {
    this.isOpen = !this.isOpen;
    this.isEditing = !this.isEditing;
    this.$root.toggleClass("active", this.isEditing);

    if (this.$context && !$(".insights-content").is(":visible")) {
      this.setContext(null);
      this.$saveToContextButton.hide();
    }

    if (!this.sections.length) {
      this.addSection();
    }

    redraw();
  }

  handleCanvasInteraction(e) {
    if (this.isEditing && this.isSectionOpen) {
      let screen_position = [e.clientX, e.clientY];
      let image_position = screen_to_image(screen_position);
      this.addCoordinatesToSection(image_position);
      this.render();
    }
    e.preventDefault();
  }

  setContext($context) {
    this.$context = $context;
    this.init();
  }

  saveToContext() {
    utils.eventBridgeApi("apply-measurement", {
      key: this.$context,
      value: Math.round(this.value.toFixed(1) * 10) / 10,
    });
  }

  resetAndHide() {
    this.init(false);
    this.$root.toggleClass("active", this.isEditing);
    redraw();
  }

  reset() {
    this.init();
  }

  init(toggle = true) {
    this.sections = [];
    this.totalLength = null;
    this.isSectionOpen = false;
    this.isEditing = false;
    this.isOpen = false;
    this.MeasuringToolColorMap = new measuringToolColors();
    if (toggle) {
      this.toggleEditable();
    }
  }

  render() {
    if (this.isOpen) {
      this.$wrapper.show();
    } else {
      this.$wrapper.hide();
    }
    if (this.$context) {
      this.$saveToContextButton.show();
    } else {
      this.$saveToContextButton.hide();
    }
    if (this.isEditing && this.sections.length > 0) {
      let sumLengths = 0;
      this.$root.find(".remove").off("click");
      this.$root.find(".section").remove();
      this.sections.map((section) => {
        section.render();
        sumLengths += section.length;
        this.$root
          .find("ul")
          .append(
            `<li class="section" style="border-right: 3px solid ${
              section.color
            }; border-left: 3px solid ${section.color}; color: ${
              section.color
            }; border-bottom: 1px solid var(--primary);">
            <span class="remove remove_measurement_icon"></span>${section.length.toFixed(1)} mm</li>`
          );
      });
      this.$root.find(".remove").on("click", this.removeSection.bind(this));
      this.totalLength = sumLengths;
      this.$total.find(".value").text(`${this.totalLength.toFixed(1)} mm`);
    }
  }
}

class MeasuringToolSection {
  length = 0;
  coords = [];
  viewerRef;
  color;

  constructor(viewer, color) {
    this.viewerRef = viewer;
    this.color = color;
  }

  addCoords(image_position) {
    this.coords.push({ x: image_position[0], y: image_position[1] });
    this.length = this.calculateLength();
  }

  calculateLength() {
    let sumLength = 0;
    let previousCoord = null;
    this.coords.map((coord) => {
      if (previousCoord) {
        let prev = image_to_screen([previousCoord.x, previousCoord.y]);
        let current = image_to_screen([coord.x, coord.y]);
        let xs = current[0] - prev[0];
        let ys = current[1] - prev[1];
        xs *= xs;
        ys *= ys;
        sumLength += Math.sqrt(xs + ys);
      }
      previousCoord = coord;
    });
    return sumLength * this.viewerRef.pixel_length_mm;
  }

  render() {
    let previousCoord = null;
    this.coords.map((coord) => {
      let screen_position = image_to_screen([coord.x, coord.y]);
      this.viewerRef.canvas_2d_context.lineWidth = 0.5;
      this.viewerRef.canvas_2d_context.shadowColor = 0;
      this.viewerRef.canvas_2d_context.shadowBlur = 0;
      this.viewerRef.canvas_2d_context.beginPath();
      this.viewerRef.canvas_2d_context.arc(
        screen_position[0],
        screen_position[1],
        4,
        0,
        2 * Math.PI,
        false
      );
      this.viewerRef.canvas_2d_context.fillStyle = this.color;
      this.viewerRef.canvas_2d_context.fill();
      this.viewerRef.canvas_2d_context.strokeStyle = "#000000";
      this.viewerRef.canvas_2d_context.stroke();

      if (previousCoord) {
        this.viewerRef.canvas_2d_context.beginPath();
        this.viewerRef.canvas_2d_context.moveTo(screen_position[0], screen_position[1]);
        let previousCoordToScreen = image_to_screen([previousCoord.x, previousCoord.y]);
        this.viewerRef.canvas_2d_context.lineTo(previousCoordToScreen[0], previousCoordToScreen[1]);
        this.viewerRef.canvas_2d_context.strokeStyle = "#000000";
        this.viewerRef.canvas_2d_context.stroke();
      } else {
        // draw rectangle
        this.viewerRef.canvas_2d_context.fillStyle = this.color;
        this.viewerRef.canvas_2d_context.font = "12pt";
        var rectangle_width = parseInt(
          this.viewerRef.canvas_2d_context.measureText(this.length.toFixed(2) + " mm").width + 10
        );
        this.viewerRef.canvas_2d_context.fillRect(
          screen_position[0] + 15,
          screen_position[1] - 24 / 2,
          rectangle_width,
          24
        );

        // write text
        this.viewerRef.canvas_2d_context.fillStyle = "#ffffff";
        this.viewerRef.canvas_2d_context.font = "12pt";
        this.viewerRef.canvas_2d_context.fillText(
          this.length.toFixed(1) + " mm",
          screen_position[0] + 20,
          screen_position[1] + 5
        );
      }
      previousCoord = coord;
    });
  }
}
